/** Contrato operativo del paraguas (hallazgo #104):
 * - En una vista divisional se muestran la liga exacta de esa división Y la
 *   liga global paraguas (division_id null) — antes el paraguas desaparecía.
 * - Al sembrar desde el paraguas DENTRO de una división, el payload lleva la
 *   división seleccionada (no null): se siembra esa división, no el torneo.
 */

export function visibleRankingLinks<T extends { division_id: number | null }>(
  links: T[],
  selectedDivisionId: number | null,
): T[] {
  if (selectedDivisionId === null) {
    return links.filter((link) => link.division_id === null);
  }
  return links.filter(
    (link) => link.division_id === selectedDivisionId || link.division_id === null,
  );
}

export function seedingDivisionIdFor(
  link: { division_id: number | null },
  selectedDivisionId: number | null,
): number | null {
  return selectedDivisionId ?? link.division_id;
}

export function isUmbrellaLink(link: { division_id: number | null }): boolean {
  return link.division_id === null;
}
